import { products } from '../../../content/career/products';
/* oxlint-disable react/forbid-elements -- Original product illustrations from the approved export. */
import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';
import { CareerProduct, CareerProducts } from '../../../components/CareerLayout/CareerProducts';

export const Products: React.FC = () => (
  <CareerProducts>
    <section className={cx('main_section_system')}>
      <img src={media.mainSystemTopBgImage} loading="lazy" alt="" className={cx('main_system_top-bg-image')} />
      <div className={cx('padding-global')}>
        <div className={cx('container-large')}>
          <div className={cx('main_content_system')}>
            <div className={cx('main_system_h2-wrapper')}>
              <img src={media.mainSystemGirlImage} loading="lazy" alt="" className={cx('main_system_girl-image')} />
              <h2 className={cx('z-index-2')}>
                {'Продуктов '}
                <br />
                {'много, '}
                <br />
                <span className={cx('text-color-brand-blue')}>{'цель одна'}</span>
              </h2>
              <div className={cx('spacer-large show-tablet')}></div>
              <div className={cx('show-tablet text-size-large')}>
                {
                  'Циан — это большая система, разделённая на автономные команды. У каждой команды свои цели, фокусы и стратегия развития.'
                }
              </div>
              <img
                src={media.mainSystemTooltipImage}
                loading="lazy"
                sizes="100vw"
                srcSet={[
                  media.mainSystemTooltipImageP500 + ' 500w',
                  media.mainSystemTooltipImageP800 + ' 800w',
                  media.mainSystemTooltipImageP1080 + ' 1080w',
                  media.mainSystemTooltipImage + ' 1251w',
                ].join(', ')}
                alt=""
                className={cx('main_system_tooltip-image')}
              />
              <div className={cx('sr-only')}>
                {
                  'Циан — это большая система, разделённая на автономные команды. Мы называем их вертикалями и горизонталями. У каждой команды свои цели, бюджеты и стратегия развития.'
                }
              </div>
            </div>
            <div className={cx('spacer-huge')}></div>
            <div className={cx('main_system_h3-wrapper')}>
              <h3 className={cx('text-size-xhuge text-style-uppercase')}>{'Вертикали'}</h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                viewBox="0 0 727 43"
                fill="none"
                className={cx('text-color-brand-blue hide-mobile-portrait system-arrow-vertical')}
                aria-hidden="true"
              >
                <rect width="714" height="7" transform="matrix(1 0 0 -1 0.164062 24.9268)" fill="currentColor"></rect>
                <path
                  d="M726.837 21.5189L706 9.53674e-05L701.219 5.17221L713.746 17.7328L713.719 25.2131L701.219 37.6809L706 42.853L726.837 21.5189Z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                viewBox="0 0 171 19"
                fill="none"
                className={cx('text-color-brand-blue show-mobile-portrait system-arrow-vertical')}
                aria-hidden="true"
              >
                <rect width="166" height="3" transform="matrix(1 0 0 -1 0.333984 11.0005)" fill="currentColor"></rect>
                <path
                  d="M170.666 9.54119L161.426 3.03115e-05L159.307 2.29328L164.861 7.86249L164.849 11.1792L159.307 16.7072L161.426 19.0005L170.666 9.54119Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className={cx('spacer-medium')}></div>
            <div className={cx('main_system_card-grid-1st')}>
              <CareerProduct product={products[0]} />
              <CareerProduct product={products[1]} />
              <CareerProduct product={products[2]} />
            </div>
            <div className={cx('spacer-xlarge')}></div>
            <div className={cx('main_system_h3-wrapper')}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                viewBox="0 0 727 43"
                fill="none"
                className={cx('text-color-brand-blue hide-mobile-portrait system-arrow-horizontal')}
                aria-hidden="true"
              >
                <rect width="714" height="7" transform="matrix(1 0 0 -1 0.164062 24.9268)" fill="currentColor"></rect>
                <path
                  d="M726.837 21.5189L706 9.53674e-05L701.219 5.17221L713.746 17.7328L713.719 25.2131L701.219 37.6809L706 42.853L726.837 21.5189Z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                viewBox="0 0 131 19"
                fill="none"
                className={cx('text-color-brand-blue show-mobile-portrait system-arrow-horizontal')}
                aria-hidden="true"
              >
                <rect width="125" height="3" transform="matrix(1 0 0 -1 0.833984 11.0005)" fill="currentColor"></rect>
                <path
                  d="M130.166 9.54119L120.926 3.05176e-05L118.807 2.29328L124.361 7.86249L124.349 11.1792L118.807 16.7072L120.926 19.0005L130.166 9.54119Z"
                  fill="currentColor"
                ></path>
              </svg>
              <h3 className={cx('text-size-xhuge text-style-uppercase')}>{'Горизонтали'}</h3>
            </div>
            <div className={cx('spacer-medium')}></div>
            <div className={cx('main_system_card-grid-2nd')}>
              <CareerProduct product={products[3]} />
              <CareerProduct product={products[4]} />
              <CareerProduct product={products[5]} />
              <CareerProduct product={products[6]} />
              <CareerProduct product={products[7]} />
            </div>
          </div>
        </div>
      </div>
    </section>
  </CareerProducts>
);
